<template>
  <div class="title-container">
    <div class="title-content">
      <springText class="item-title" text="Bounty Squad"></springText>
    </div>
    <fadeInAnimation>
      <div class="sub-title">
        Create a bounty squad of 1 to 5 characters, with mining results processed in order of their assigned numbers.
        When
        the stamina of the first member is depleted, the next member will take over.
      </div>
    </fadeInAnimation>
  </div>
</template>

<script>
import responsiveMixin from "@/mixins/responsive";
import springText from "@/views/components/springText";
import fadeInAnimation from "@/views/components/fadeInAnimation";

export default {
  mixins: [responsiveMixin],
  components: { springText, fadeInAnimation },
  data() {
    return {};
  },
  mounted() { },
  methods: {},
  watch: {

  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>